var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureCardThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 7.99992H18.3333M7.66667 13.3333H15.6667M21 1.33325C22.0609 1.33325 23.0783 1.75468 23.8284 2.50482C24.5786 3.25497 25 4.27239 25 5.33325V15.9999C25 17.0608 24.5786 18.0782 23.8284 18.8283C23.0783 19.5785 22.0609 19.9999 21 19.9999H14.3333L7.66667 23.9999V19.9999H5C3.93913 19.9999 2.92172 19.5785 2.17157 18.8283C1.42143 18.0782 1 17.0608 1 15.9999V5.33325C1 4.27239 1.42143 3.25497 2.17157 2.50482C2.92172 1.75468 3.93913 1.33325 5 1.33325H21Z",
    stroke: "#5D34F3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureCardThree);
export default __webpack_public_path__ + "static/media/featureCardThree.b8374799117cb9e1b4762e8ee37c6f34.svg";
export { ForwardRef as ReactComponent };